import { z } from 'zod';

/** A 6-digit hex colour, e.g. #0D2B4A. */
export const HexColorSchema = z
  .string()
  .trim()
  .regex(/^#[0-9a-fA-F]{6}$/, 'Enter a 6-digit hex colour, e.g. #0D2B4A');

/**
 * Body of PATCH /api/v1/admin/branding. All fields optional — only the keys
 * present are updated. `signature_html` is sanitised server-side before it is
 * stored (it renders in emails + PDFs). `logo_url` is intentionally NOT settable
 * here yet — logo upload is a separate slice once object storage exists.
 */
export const UpdateBrandingSchema = z
  .object({
    primary_color: HexColorSchema.optional(),
    signature_html: z.string().max(10_000, 'Signature is too long').optional(),
  })
  .strict();

export type UpdateBrandingInput = z.infer<typeof UpdateBrandingSchema>;
